import Navbar from "../components/Navbar"
import ServicesComponent from "../components/ServicesComponent"
import Footer from "../components/Footer"
import SEOMetaTags from "../components/SEOMetaTags"

function Services() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMetaTags 
        title="Hizmetlerimiz - Buğra Teknik Servis"
        description="Doğal gaz tesisatı, su tesisatı, kombi bakım onarım, klima servisi, beyaz eşya servisi ve daha fazlası. Karabük'te profesyonel teknik servis hizmetleri."
      />
      <Navbar />
      <div className="pt-16">
        <ServicesComponent />
      </div>
      <Footer />
    </div>
  )
}

export default Services
